// extracted by mini-css-extract-plugin
module.exports = {"shadowStyle":"style_shadowStyle__dOUAk"};